"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEND_POST_BACK = void 0;
exports["default"] = sendPostback;
var SEND_POST_BACK = 'WEB_CHAT/SEND_POST_BACK';
exports.SEND_POST_BACK = SEND_POST_BACK;

function sendPostback(value) {
  return {
    type: SEND_POST_BACK,
    payload: {
      value: value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRU5EX1BPU1RfQkFDSyIsInNlbmRQb3N0YmFjayIsInZhbHVlIiwidHlwZSIsInBheWxvYWQiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zZW5kUG9zdEJhY2suanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VORF9QT1NUX0JBQ0sgPSAnV0VCX0NIQVQvU0VORF9QT1NUX0JBQ0snO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZW5kUG9zdGJhY2sodmFsdWUpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRU5EX1BPU1RfQkFDSyxcbiAgICBwYXlsb2FkOiB7IHZhbHVlIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VORF9QT1NUX0JBQ0sgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLGNBQWMsR0FBRyx5QkFBdkI7OztBQUVlLFNBQVNDLFlBQVQsQ0FBc0JDLEtBQXRCLEVBQTZCO0VBQzFDLE9BQU87SUFDTEMsSUFBSSxFQUFFSCxjQUREO0lBRUxJLE9BQU8sRUFBRTtNQUFFRixLQUFLLEVBQUxBO0lBQUY7RUFGSixDQUFQO0FBSUQifQ==